import React from 'react';
import { useNavigate} from 'react-router-dom';
import { Container, Typography, Button } from '@mui/material';
export default function CancelPage() {
  const navigate = useNavigate();
    const back = async (e) => {
      e.preventDefault();
      navigate('/login');
    };
  return (
    <Container>
      <Typography variant="h4" color="error">Pagamento fallito. Riprovare più tardi</Typography>
      <Button variant="contained" onClick={back}>Vai alla pagina tardi Login</Button>
    </Container>
  );
}